import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import ProductSelect from "../../../components/Custom/Main/Product/ProductSelect";
import InputNumeric from "../../../components/Forms/Element/InputNumeric";
import FieldValidationError from "../../../components/Forms/Element/FieldValidationError";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import HintTooltip from "../../../components/Common/HintTooltip";

const Form = (props) => {

    const { t } = useTranslation();
    const { status, setStatus, formik, entityData } = props;

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('score', entityData.score);
            formik.setFieldValue('price', entityData.price);
            setStatus(convertStatusToBoolean(entityData.status));

            if (entityData.product !== null) {
                formik.setFieldValue('product', {
                    value: entityData.product.id,
                    label: entityData.product.name
                });
            }
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <div className="form-layout__panel">
                    <div className="form-layout__panel-header">
                        <div>
                            <h5 className="mb-1">{t('basic_information')}</h5>
                            <p className="mb-0">{t('gamification_score_basic_information_hint')}</p>
                        </div>
                    </div>

                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('product')} <AsteriskRequired /></FormLabel>
                                <ProductSelect
                                    name="product"
                                    value={formik.values.product}
                                    onChange={(value) => {
                                        formik.setFieldValue('product', value);
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                                <FieldValidationError error={formik.errors.product} />
                            </FormGroup>
                        </Col>

                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('gamification.score')} <AsteriskRequired /> <HintTooltip text={t('gamification_score_hint')} /></FormLabel>
                                <InputNumeric
                                    name="score"
                                    value={formik.values.score}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <FieldValidationError error={formik.errors.score} />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>

                <div className="form-layout__panel form-layout__panel--compact">
                    <div className="form-layout__panel-header">
                        <div>
                            <h5 className="mb-1">{t('status')}</h5>
                            <p className="mb-0">{t('gamification_score_status_hint')}</p>
                        </div>
                    </div>

                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default Form;
